
export const DASHBORD_1 = "/Dashboard_1"
export const DASHBORD_2 = "/Dashboard_2"
export const SUPER_ADMIN_DASHBOARD = "/SuperAdminDashboard"
// ***************************** Utility **************************************//

export const SEARCH_BOX2 = "/SearchBoxSecond"
export const SEARCH_BOX3 = "/SerachBox3"
export const TRANSACTION_LOG = "/TransactionLog"
export const POS_LOG = "/POS_Log"

// *************************** Administration *******************************//

export const MODULE = "/ModuleMaster"
export const MODULE_lIST = "/ModuleList"

export const COMPANY = "/CompanyMaster"
export const COMPANY_lIST = "/CompanyList"

export const USER = "/UserMaster"
export const USER_lIST = "/UserList"


export const ROLE = "/RoleMaster"
export const ROLE_lIST = "/RoleList"

export const ROLEACCESS = "/RoleAccess"
export const ROLEACCESS_lIST = "/RoleAccessList"
export const COPY_ROLEACCESS = "/RoleAccessCopyFunctionality"

// *************************** Master Module **********************************//

export const MINI_ITEM_MASTER = "/Mini_Item_Master"
export const MAPPING_MASTER = "/MappingMaster"

export const NOC_DOCUMENT_UPLOAD = "/NocDocumentUpload"
export const NOC_LIST_PAGE = "/NocListPage"

export const ITEM = "/ItemMaster"
export const ITEM_lIST = "/ItemList"

export const GST = "/GSTMaster"
export const GST_LIST = "/GSTList"


export const SCHEME_MASTER = "/Scheme_Master"
export const SCHEME_MASTER_LIST = "/Scheme_Master_List"

export const BILL_PROCESSING_REPORT = "/Bill_Processing_Report"

export const RATE_LIST_REPORT = "/RateListReport"

export const LOYALTY_CLAIM_REPORT = "/LoyaltyClaims"
export const POS_DASHBOARD_DETAILS = "/POSDashBoardDetails"


export const COMPANYGROUP = "/CompanyGroupMaster"
export const COMPANYGROUP_lIST = "/CompanyGroupList"

export const EMPLOYEE = "/EmployeeMaster"
export const EMPLOYEE_lIST = "/EmployeeList"

export const EMPLOYEETYPE = "/EmployeeType"
export const EMPLOYEETYPE_lIST = "/EmployeeTypeList"

export const CATEGORYTYPE = "/CategoryTypeMaster"
export const CATEGORYTYPE_lIST = "/CategoryTypeList"

export const DRIVER = "/DriverMaster"
export const DRIVER_lIST = "/DriverList"

export const PARTY = "/PartyMaster"
export const PARTY_lIST = "/PartyList"

export const RETAILER_MASTER = "/RetailerMaster"
export const RETAILER_LIST = "/RetailerList"

export const RETAILER_MASTER_1 = "/Retailer_Master_1"
export const RETAILER_MASTER_LIST_1 = "/Retailer_Master_List_1"



export const NON_RETAILER_PARTY = "/Non_Retailer_Party"
export const NON_RETAILER_PARTY_lIST = "/Non_Retailer_Party_List"

export const PARTY_SELF_EDIT = "/PartySelfEdit"

export const PARTYTYPE = "/PartyType"
export const PARTYTYPE_lIST = "/PartyTypeList"

export const CATEGORY = "/CategoryMaster"
export const CATEGORY_lIST = "/CategoryList"

export const VEHICLE = "/VehicleMaster"
export const VEHICLE_lIST = "/VehicleList"

export const GROUPTYPE = "/GroupTypeMaster"
export const GROUPTYPE_lIST = "/GroupTypeList"

export const ROUTES = "/RoutesMaster"
export const ROUTES_LIST = "/RoutesList"

export const SALESMAN = "/SalesManMaster"
export const SALESMAN_LIST = "/SalesManList"

export const GROUP = "/GroupMaster"
export const GROUP_lIST = "/GroupList"

export const GROUP_SUBGROUP = "/Group_SubGroup"


export const PRICE = "/PriceMaster"
export const PRICE_lIST = "/PriceList"

export const MRP = "/MRPMaster"
export const MRP_lIST = "/MRPList"

export const MARGIN = "/MarginMaster"
export const MARGIN_lIST = "/MarginList"

export const PAGE = "/PageMaster"
export const PAGE_lIST = "/PageList"

export const TERMS_AND_CONDITION = "/TermsAndCondtionsMaster"
export const TERMS_AND_CONDITION_LIST = "/TermsAndCondtionsList"
export const PARTY_SUB_PARTY = "/PartySubParty"
export const PARTY_SUB_PARTY_lIST = "/PartySubPartyList"

export const PARTYITEM = '/PartyItems';

export const VENDOR_PRODUCTION = '/VendorProduction';
export const VENDOR_PRODUCTION_LIST = "/VendorProductionList"


export const CHANNEL_ITEM = '/ChannelItem';

export const CUSTOMER_ITEM_ASSIN = '/CustomerItemAssin';

export const SUBGROUP = "/SubGroupMaster"
export const SUBGROUP_LIST = "/SubGroupList"

export const GENERAL = "/GeneralMaster"
export const GENERAL_LIST = "/GeneralList"

export const CITY = "/CityMaster"
export const CITY_LIST = "/CityList"

export const IMPORT_EXCEL_FIELD_MAP = "/Import_ExcelFieldMap"

export const IMPORT_CREDIT_NOTE_EXCEL_FIELD_MAP = "/Credit_Note_Excel_Field_Map"

export const TARGET_UPLOAD = "/Target_Upload"

export const TARGET_UPLOAD_LIST = "/Target_Upload_List"

export const PARTY_EMPLOYEE_DETAILS = "/PartyEmployeeDetails"

export const INVOICE_EXCEL_UPLOAD = "/Invoice_Excel_Upload"
export const RETAILER_EXCEL_UPLOAD = "/Retailer_Excel_Upload"

export const IMPORT_FIELD_ADD = "/ImportFieldAdd"
export const IMPORT_FIELD_ADD_LIST = "/ImportFieldAddList"

export const IMPORT_EXCEL_PARTY_MAP = "/ImportExcelPartyMap"

export const ROUTE_UPDATE = "/RouteUpdate"

export const PARTY_MASTER_BULK_UPDATE = "/PartyMasterBulkUpdate"

export const MANAGEMENT_PARTIES = "/ManagementParties"

export const BANK = "/BankMaster"
export const BANK_LIST = "/BankList"

export const PRODUCT_MARGIN_REPORT = "/ProductMarginReport"

export const DISCOUNT_MASTER = "/Discount_Master"
export const DISCOUNT_LIST = "/Discount_List"

export const CLUSTER_MASTER = "/Cluster_Master"
export const CLUSTER_lIST = "/Cluster_List"

export const SUB_CLUSTER_MASTER = "/SubCluster_Master"
export const SUB_CLUSTER_lIST = "/SubCluster_List"

export const CENTRAL_SERVICE_ITEM_MASTER = "/CentralServiceItem"
export const CENTRAL_SERVICE_ITEM_lIST = "/CentralServiceItemList"

export const SERVICE_ITEM_ASSIGN = "/Service_Item_Assign"

export const PARTY_DETAILS = "/Party_Details"

export const ITEM_MASTER_BULK_UPDATE = "/ItemMasterBulkUpdate"

export const ITEM_SUPPLIER_ASSIGN = "/Item_Supplier_Assign"

export const ITEM_IMAGE_UPLOAD = "/ItemImageUpload"

export const CREDIT_NOTE_UPLOAD = "/CreditNoteUpload"

export const RATE_MASTER = "/Rate_Master"
export const RATE_LIST = "/Rate_List"

export const FRANCHISE_CUSTOMER_MASTER = "/Franchise_Customer_Master"

export const FRANCHISE_CUSTOMER_LIST = "/Franchise_Customer_List"

export const COUNTRY_MASTER = "/Country_Master"
export const COUNTRY_LIST = "/Country_List"

export const VOUCHER = "/Voucher"
export const VOUCHER_LIST = "/Voucher_List"


export const SCHEME_TYPE = "/Scheme_Type"

export const SCHEME_TYPE_LIST = "/Scheme_Type_List"

export const FRANCHISE_PARTY_MASTER = "/Franchise_Party_Master"

//******************************* Generic Massages  ************************************//
export const GENERIC_MESSAGE_MASTER = "/Generic_POS_Messages_Master"
export const GENERIC_MESSAGE_LIST = "/Generic_POS_Messages_Master_List"

export const India_Portal_Registration = "/India_Portal_Registration"



//******************************* Purchase Module ************************************//
export const ORDER_1 = "/Order_1"
export const ORDER_LIST_1 = "/OrderList_1"

export const ORDER_2 = "/Order_2"
export const ORDER_LIST_2 = "/OrderList_2"

export const ORDER_4 = '/Order_4'
export const ORDER_LIST_4 = '/OrderList_4'

export const APP_ORDER_LIST = "/App_Order_List"

export const PURCHASE_RETURN = "/PurchaseReturn"
export const PURCHASE_RETURN_LIST = "/PurchaseReturnList"

export const ORDER_APPROVAL = "/OrderAccountingApproval"

//******************************* Inventory Module ************************************//

export const GRN_STP_1 = "/GRN_STP_1"
export const GRN_LIST_1 = "/GRN_LIST_1"
export const GRN_ADD_1 = "/GRN_ADD_1"

export const GRN_FOR_ACCOUNTING_GRN = "/GRN_For_Accounting_GRN"

export const WASTAGE_ENTRY_MASTER = '/WastageEntryMaster'
export const WASTAGE_LIST = '/WastageList'

export const ACCOUNTING_GRN = "/Accounting_GRN"

export const IB_GRN = "/IB_GRN"


export const ACCOUNTING_GRN_LIST = "/Accounting_GRN_List"

export const GRN_STP_3 = "/GRN_STP_3"
export const GRN_LIST_3 = "/GRN_LIST_3"
export const GRN_ADD_3 = "/GRN_ADD_3"

export const IB_INVOICE_LIST = "/ChallanList"
export const IB_INVOICE = "/Challan"

export const STOCK_ENTRY = "/Stock_Entry"

export const STOCK_ENTRY_LIST = "/Stock_Entry_List"

export const STOCK_ADJUSTMENT = "/StockAdjustment"

export const STOCK_ADJUSTMENT_LIST = "/Stock_Adjustment_List"

export const STOCK_ADJUSTMENT_MODE_2 = "/StockAdjustmentMode_2"

//*******************************All report page ************************************//
export const REPORT = "/Report"

//******************************* Production Module ************************************//

export const BIllOf_MATERIALS = "/BOM"
export const BIllOf_MATERIALS_LIST = "/BOMList"

export const WORK_ORDER = "/WorkOrder"
export const WORK_ORDER_LIST = "/WorkOrderList"

export const BULK_WORK_ORDER = "/Bulk_Work_Order"

export const BULK_WORK_ORDER_LIST = "/Bulk_Work_Order_List"

export const FRENCHIESE_SALE_REPORT = "/Frenchies_Item_sale_Report"


export const DAILY_SALE_REPORT = '/Daily_Sale_Report'


export const DEMAND_VS_SUPPLY_REPORT = "/Demand_Vs_Supply_Report"


export const GRN_PENDING_REPORT = "/GrnpendingReport"


export const DATA_EXPORT_TO_SAP = "/Data_Export_To_SAP"


export const GRN_DISCREPANCY_REPORT = "/GRN_Discrepancy_Report"

export const CODE_REDEMPTION_REPORT = "/Code_Redemption_Report"




export const Bill_Delete_Summary_Report = "/Bill_Delete_Summary_Report"



export const CashBookHead = "/CashBookHead"
export const CashBookHeadList = "/CashBookHeadList"







export const MATERIAL_ISSUE = "/MaterialIssue"
export const MATERIAL_ISSUE_LIST = "/MaterialIssueList"
export const MATERIAL_ISSUE_STP = "/MaterialIssue_STP"

export const PRODUCTION_MASTER = "/ProductionMaster"
export const PRODUCTION_LIST = "/ProductionList"
export const PRODUCTION_STP = "/Production_STP"

export const PRODUCTION_REISSUE = "/ProductionReIssue"
export const PRODUCTION_REISSUE_LIST = "/ProductionReIssueList"
export const PRODUCTION_REISSUE_STP = "/ProductionReIssue_STP"

//******************************* Sale Module ************************************//

export const INVOICE_1 = "/Invoice_1"
export const INVOICE_LIST_1 = "/InvoiceList_1"

export const FRANCHAISE_INVOICE = "/Franchies_Invoice"

export const LOADING_SHEET = "/Loading_Sheet"
export const LOADING_SHEET_LIST = "/Loading_Sheet_List"
export const LOADING_SHEET_LIST_UPDATE = "/Loading_Sheet_List_Update"

export const SALES_RETURN = "/SalesReturn"
export const SALES_RETURN_LIST = "/SalesReturnList"

export const PURCHASE_RETURN_MODE_3 = "/Purchase_Return_Mode_3"

export const BULK_INVOICE = "/Bulk_Invoice"
//******************************* InterBranch Module ************************************//

export const IB_ORDER = "/IB_Order" // IB Order

export const IB_SALES_ORDER = "/IB_Sales_Order" // IB Order

export const IB_ORDER_PO_LIST = "/IB_Order_PO_List" //IB Order List
export const IB_ORDER_SO_LIST = "/IB_Order_SO_List" //IB Order List

export const ORDER_QUATATION = "/Order_Quotation" //IB Order List
export const ORDER_QUATATION_LIST = "/Order_Quotation_Check_List" //IB Order List

export const INWARD = "/Inward"
export const INWARD_LIST = "/InwardList"
export const IB_INWARD_STP = "/IB_Inward_STP"


export const IB_GRN_LIST = "/IB_GRN_LIST" // IB GRN List

export const IB_INVOICE_FOR_GRN = "/IB_INVOICE_FOR_GRN" // IB GRN List

export const IB_INVOICE_STP = "/IB_Invoice_STP" // IB Invoice from IB Order List

export const VDC_INVOICE = "/VDC_Invoice" // IB Invoice
export const VDC_INVOICE_LIST = "/VDC_Invoice_List" // IB Invoice List


export const PERIODIC_GRN_REPORT = "/Periodic_GRN_Report" // IB Invoice List


//********************************Accounting ***********************************//

export const RECEIPTS = "/Receipts"
export const RECEIPTS_LIST = "/ReceiptList"

export const RECEIPTS_LIST_2 = "/Receipt_List_2"

export const BULK_RECIPT = "/BulkRecipt"

export const PAYMENT_ENTRY = "/PaymentEntry"
export const PAYMENT_ENTRY_LIST = "/PaymentEntryList"

export const BANK_ASSIGN = "/BankAssign"

export const CLAIM_TRACKING_ENTRY = "/ClaimTrackingEntry"
export const CLAIM_TRACKING_ENTRY_LIST = "/ClaimTrackingEntryList"

export const DAILY_DISPATCH_REPORT = "/Daily_Dispatch_Report"


export const INVOICE_CONFIGURATION = "/InvoiceConfiguration"

export const MANAGEMENT_SETTINGS = "/ManagementSettings"

export const CREDIT_NOTE = "/Credit"
export const CREDIT_LIST = "/Credit_List"

export const DEBIT_NOTE = "/Debit"
export const DEBIT_LIST = "/Debit_List"

export const GOODS_CREDIT_NOTE = "/GoodsCreditNote"
export const GOODS_CREDIT_LIST = "/GoodsCreditNoteList"

export const GOODS_DEBIT_NOTE = "/GoodsDebitNote"
export const GOODS_DEBIT_LIST = "/GoodsDebitNoteList"

export const CREDIT_NOTE_1 = "/Credit_Note_1"
export const CREDIT_NOTE_LIST_1 = "/Credit_Note_List_1"

//**************************** Reports ***********************************//

export const SAP_LEDGER = "/SapLedger";

export const PARTY_LEDGER = "/PartyLedger";

export const SELF_LEDGER = "/SelfLedger";

export const CURRENT_STOCK_REPORT = "/StockReport"

export const SNS_REPORT = "/Stock_Report_1"

export const ORDER_SUMMARY_REPORT = "/OrderSummaryReport"

export const GENERIC_SALE_REPORT = "/Generic_Sale_Report"

export const RETAILER_DATA_REPORT = "/RetailerDataReport"



export const CLAIM_SUMMARY_MASTER = "/Claim_Summary_Master"

export const CLAIM_SUMMARY_lIST = "/Claim_Summary_List"

export const PURCHASE_GST_REPORT = "/PurchaseGSTReport"

export const INVOICE_DATA_EXPORT = "/InvoiceDataExport"

export const PURCHASE_DATA_EXPORT = "/PurchaseDataExport"

export const DELETE_INVOICE_DATA_EXPORT = "/DeleteInvoiceDataExport"

export const DAMAGE_STOCK_REPORT = "/Damage_Stock_Report"

export const GST_R1_REPORT = "/Gst_R1_Report"

export const RETURN_REPORT = "/ReturnReport"

export const ITEM_SALE_REPORT = "/Item_Sale_Report"

export const MATERIAL_REGISTER_REPORT = "/MaterialRegister"

export const DEBIT_DATA_EXPORT = "/DebitDataExport"

export const CREDIT_DATA_EXPORT = "/CreditDataExport"

export const RECEIPT_DATA_EXPORT = "/ReceiptDataExport"

export const PARTY_OUTSTANDING_REPORT = "/PartyOutstandingReport"

export const RETAILER_APPROVAL = "/RetailerApproval"

export const MOBILE_RETAILER_SEND = "/MobileRetailerSend"

export const MAN_POWER_REPORT = "/ManPowerReport"

export const CLAIM_TRACKING_REPORT = "/Claim_Tracking_Report"

export const TCS_AMOUNT_REPORT = "/TCS_Amount_Report"

export const CX_DD_DIFFERENCE_REPORT = "/CX_DD_Difference"

export const Css_Item_Sale_Report = "/CSS_Item_sale_Report"

export const MANAGER_SUMMARY_REPORT = "/Manager_Summary_Report"

export const ITEM_CONSUMPTION_REPORT = "/Item_Consumption_Report"

export const SERVICE_SETTINGS = "/SERVICE_SETTINGS"

export const POS_SERVICE_SETTING = "/Pos_Setting"
export const POS_SERVICE_SETTING_LIST = "/Pos_Setting_List"


export const PHONE_PAY_SETTING = "/Phone_Pay_Setting"
export const PHONE_PAY_SETTING_LIST = "/Phone_Pay_Setting_List"


export const SYSTEM_SETTING = "/System_Setting"

export const SYSTEM_SETTING_LIST = "/System_Setting_List"

export const TARGET_VS_ACHIEVEMENT = "/TargetVSAchievement"

export const ORDER_ITEM_SUPPLIER_REPORT = "/Order_Item_Supplier_Report"

export const VOUCHER_REDEMPTION_CLAIM_ = "/Voucher_Redeemption_Claim"

export const RATE_ADJUSTMENT = "/Rate_Adjustment"

export const BATCH_TRACEABILITY = "/Batch_Traceability_Report"

export const CHALLAN_MASTER = "/MasterChallan"
export const CHALLAN_MASTER_LIST = "/ListChallan"

export const CSS_BULK_INVOICE = "/CSSBulkInvoice"

export const FRANCHISE_LICENSE = "/FranchiseLicense"


//**************************** Sweet Pos ***********************************//

export const POS_ROLE_ACCESS = "/POS_RoleAccess"

export const POS_USER = "/POS_User"

export const POS_USER_lIST = "/POS_User_List"

export const POS_INVOICE_LIST = "/Pos_InvoiceList"


export const POS_INVOICE_LIST_IN_POS = "/Pos_InvoiceList/AuthLink/:Credentials"

export const POS_ORDER_IN_POS = "/Order_2/AuthLink/:Credentials"

export const POS_ORDER_LIST_IN_POS = "/OrderList_2/AuthLink/:Credentials"


export const CASHIER_SUMMARY_REPORT = "/Cashier_Summary_Report"

export const SWEET_POS_RATE_MASTER = "/SweetPOS_Rate_Master"

export const SWEET_POS_MACHINE_MASTER = "/SweetPOS_Machine_Master"

export const SWEET_POS_MACHINE_LIST = "/SweetPOS_Machine_List"

export const STOCK_OUT_REPORT = "/Stock_Out_Report"

export const BILL_BOOKING_REPORT = "/Bill_Booking_Report"

export const FRANCHAISE_SALE_WITH_BILL_COUNT = "/Franchise_Sale_With_Bill_Count"


export const POS_SALE_SUMMARY_REPORT = "/POS_Summary_Sale_Report"

export const STOCK_ADJUSTMENT_REPORT = "/Stock_Adjustment_Report"

export const SWIGGY_ZOMATO_CLAIM = "/Swiggy_Zomato_Claim"

export const PARTY_WISE_ITEM_SALE_REPORT = "/Party_Wise_Item_Sale_Report"

export const PERIOD_WISE_INVOICE_REPORT = "/Period_Wise_Invoice_Report"
export const ANNUAL_ITEM_SALE_REPORT = "/ANNUAL_ITEM_SALE_REPORT"

export const Frenchises_Dashboard = "/Frenchises_Dashboard"

export const MBQ_AND_MVQ = "/MBQ_AND_MVQ"

export const ERP_URL_L = `/ERPURLs`
export const ERP_URL_M = `/ERPURMs`

export const CASH_BOOK_ENTRY = "/CashBookEntry"
export const CASH_BOOK_ENTRY_LIST = "/CashBookEntryList"

export const CASH_BOOK_ENTRY_REPORT = "/CashBookEntryReport"